import React, { useState } from "react";
import styles from "./Deposits.module.css";
import { FiEdit2 } from "react-icons/fi";
import { useDispatch } from "react-redux";
import { openModal } from "../../redux/slices/modalSlice";
import ResultAndCount from "../../components/ResultAndCount/ResultAndCount";
import Dropdown from "../../components/Dropdown/Dropdown";
import SearchBar from "../../components/SearchBar/SearchBar";
import PaginationTable from "../../components/PaginationTable/PaginationTable";
import DynamicTable from "../../components/DynamicTable/DynamicTable";
import LogoWithName from "../../components/LogoWithName/LogoWithName";
import IconAndName from "../../components/IconAndName/IconAndName";
import { MdOutlineTextSnippet } from "react-icons/md";
import CopyRight from "../../components/CopyRight/CopyRight";
import { IoMdTrash } from "react-icons/io";
import { useNavigate } from "react-router-dom";

const data = [
  {
    _id: "s1",
    studentName: "John Jacob",
    depositIssued: 2600,
    depositUsed: 3600,
    transferredToCredit: 3600,
    depositRefunded: 2400,
    depositBalance: 2400,
  },
  {
    _id: "s2",
    studentName: "Jane Smith",
    depositIssued: 2200,
    depositUsed: 2000,
    transferredToCredit: 2000,
    depositRefunded: 0,
    depositBalance: 200,
  },
  // Add more as needed...
];


  

const Deposits = () => {
  const dispatch = useDispatch();
  const [count, setCount] = useState(7);
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [selectedIds, setSelectedIds] = useState([]);

  const totalIssued = data.reduce((sum, d) => sum + (d.depositIssued || 0), 0);
  const totalUsed = data.reduce((sum, d) => sum + (d.depositUsed || 0), 0);
  const totalRefunded = data.reduce(
    (sum, d) => sum + (d.depositRefunded || 0),
    0
  );
  const totalBalance = data.reduce(
    (sum, d) => sum + (d.depositBalance || 0),
    0
  );
  const navigate = useNavigate();
  
  const handlecreateform = () => {
    dispatch(openModal("addDeposit"));
  };
  const handleEditClick = () => {
    dispatch(openModal("chooseRange"));
  };
  const handleArchiveClick = () => {
    navigate("/deposithistory");
  };
  const totalInvoiced = data.reduce(
    (sum, s) => sum + (s.invoicedAmount || 0),
    0
  );
  const totalPaid = data.reduce((sum, s) => sum + (s.paidAmount || 0), 0);
  const totalPending = data.reduce((sum, s) => sum + (s.pendingAmount || 0), 0);

  const headingsData = [
    {
      title: (
        <input
          type="checkbox"
          checked={selectedIds.length === data.length}
          onChange={(e) => {
            const checked = e.target.checked;
            if (checked) {
              const allIds = data.map((item) => item._id);
              setSelectedIds(allIds);
            } else {
              setSelectedIds([]);
            }
          }}
        />
      ),
      accessor: "checkBox",
    },
    { title: "Student Name", accessor: "studentName" },
    { title: "Deposit Issued", accessor: "depositIssued" },
    { title: "Deposit Used", accessor: "depositUsed" },
    { title: "Transferred to Credit", accessor: "transferredToCredit" },
    { title: "Deposit Refunded", accessor: "depositRefunded" },
    { title: "Deposit Balance", accessor: "depositBalance" },
  ];
  


  const getColumnData = (data) => {
    return data.map((item) => {
      const isChecked = selectedIds.includes(item._id);
      return {
        checkBox: (
          <input
            type="checkbox"
            checked={isChecked}
            onChange={(e) => {
              const checked = e.target.checked;
              if (checked) {
                setSelectedIds((prev) => [...prev, item._id]);
              } else {
                setSelectedIds((prev) => prev.filter((id) => id !== item._id));
              }
            }}
          />
        ),
        studentName: <LogoWithName name={item.studentName || "-"} />,
        depositIssued:
          item.depositIssued != null ? `INR ${item.depositIssued}` : "-",
        depositUsed: item.depositUsed != null ? `INR ${item.depositUsed}` : "-",
        transferredToCredit:
          item.transferredToCredit != null
            ? `INR ${item.transferredToCredit}`
            : "-",
        depositRefunded:
          item.depositRefunded != null ? `INR ${item.depositRefunded}` : "-",
        depositBalance:
          item.depositBalance != null ? `INR ${item.depositBalance}` : "-",
      };
    });
  };
  

  const displayData = getColumnData(data);

  return (
    <>
      <div className={styles.mainContainer}>
        <div className={styles.container}>
          <div className={styles.createForm}>
            <button className={styles.archiveBtn} onClick={handleArchiveClick}>
              Deposit History
            </button>
            <IconAndName
              icon={<MdOutlineTextSnippet />}
              title="Add Deposit"
              bgColor="Primary_Color"
              onClick={handlecreateform}
            />
          </div>
          {/* 🟩 Result Cards + This Month */}
          <div className={styles.rowWrapper}>
            <div className={styles.cardsWrapper}>
              <ResultAndCount
                label="Deposit Issued"
                count={` ${totalIssued}/-`}
                bgColor="rgba(from var(--Success_Color) r g b / 0.4)"
                textColor="Black_Color"
                
              />
              <ResultAndCount
                label="Deposit Used"
                count={` ${totalUsed}/-`}
                bgColor="rgba(from var(--Primary_Color) r g b / 0.35)"
                textColor="Black_Color"
              />
              <ResultAndCount
                label="Deposit Refunded"
                count={` ${totalRefunded}/-`}
                bgColor="rgba(from var(--Warning_Color) r g b / 0.3)"
                textColor="Black_Color"
              />
              <ResultAndCount
                label="Deposit Balance"
                count={` ${totalBalance}/-`}
                bgColor="rgba(from var(--Error_Color) r g b / 0.4)"
                textColor="Black_Color"
              />
            </div>

            <div className={styles.editWrapper} onClick={handleEditClick}>
              <FiEdit2 size={16} />
              <span>This Month</span>
            </div>
          </div>

          {/* 🔍 Search & Filters Row */}
          <div className={styles.totalstudentcard}>
            <div className={styles.studentsection}>
              <div className={styles.search}>
                <SearchBar
                  placeholder="Search Student"
                  onChange={(e) => console.log(e.target.value)}
                />
              </div>
              <div className={styles.filters}>
                <Dropdown
                  label="Student Status"
                  options={["Annual Day", "Freshers"]}
                  bgColor="rgba(from var(--Utility_Color1) r g b / 1)"
                />
                <Dropdown
                  label="Program"
                  options={["Annual Day", "Freshers"]}
                  bgColor="rgba(from var(--Utility_Color1) r g b / 1)"
                />
                <Dropdown
                  label="Group"
                  options={["Group 1", "Group 2"]}
                  bgColor="rgba(from var(--Utility_Color1) r g b / 1)"
                />
                <Dropdown
                  label="Room"
                  options={["Room1", "Room2"]}
                  bgColor="rgba(from var(--Primary_Color) r g b / 1)"
                />
                <IoMdTrash
                  size={26}
                  style={{
                    marginTop: "0.5rem",

                    opacity: 0.4,
                    color: "var(--Black_Color)",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    dispatch(openModal("delete"));
                  }}
                />
              </div>
            </div>

            {/* Student Data Table */}
            <div className={styles.dynamicdata}>
              <DynamicTable
                headings={headingsData}
                columnData={displayData.slice(
                  (currentPage - 1) * itemsPerPage,
                  currentPage * itemsPerPage
                )}
              />
            </div>
            <div className={styles.paginationTable}>
              <PaginationTable
                data={displayData}
                currentPage={currentPage}
                itemsPerPage={itemsPerPage}
                setCurrentPage={setCurrentPage}
                setItemsPerPage={setItemsPerPage}
              />
            </div>
          </div>
        </div>
      </div>
      <CopyRight />
    </>
  );
};

export default Deposits;
